import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import { getInputField, getFormatNumber } from '../subscriptor/forms/fields';
import { maintainerForm as styles } from '../maintainer/styles';
import {
  RISK_NAME_MAX_LENGTH,
  RISK_NUMBER_MAX_LENGTH,
  RISK_MAX_LENGTH_ORDER
} from '../../libraries/constants';
import { maximumSubString, OnlyNumber } from '../../libraries/utils';

const Form = props => {
  const { values, classes, handleBlur, errors, touched, setFieldValue, title } = props;

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue
  };

  return (
    <Card className={classes.card}>
      <CardHeader title={title} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            {getInputField({
              ...fieldProps,
              name: `name`,
              label: `Nombre`,
              required: true,
              changeHandler: maximumSubString(RISK_NAME_MAX_LENGTH),
              formControlClass: classes.fullWidth
            })}

            {getInputField({
              ...fieldProps,
              name: `riskNumber`,
              label: 'Número de riesgo',
              required: true,
              changeHandler: value => maximumSubString(RISK_NUMBER_MAX_LENGTH)(OnlyNumber(value)),
              formControlClass: classes.fullWidth
            })}
            {getFormatNumber({
              ...fieldProps,
              name: `order`,
              thousandSeparator: '',
              allowEmptyFormatting: true,
              label: 'Orden',
              required: true,
              maxDigitLimit: RISK_MAX_LENGTH_ORDER,
              formControlClass: classes.fullWidth
            })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

Form.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Form);
